<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <!--
      (1)在HTML中
      {{ $t('key.value') }}
      (`2)在script中
      console.log( this.$t('key.value') );`
    -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :md="6" :sm="12">
            <mtc-form-item label="label.code">
              <a-input :placeholder="$t('tip.pleaseInput') + $t('label.code')" v-model="queryParam.code"></a-input>
            </mtc-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <mtc-form-item label="label.description">
              <a-input :placeholder="$t('tip.pleaseInput') + $t('label.description')" v-model="queryParam.name"></a-input>
            </mtc-form-item>
          </a-col>
<!--          <template v-if="toggleSearchStatus">-->
            <a-col :md="6" :sm="12">
              <mtc-form-item label="label.applicableBusiness">
                <j-dict-select-tag type="list" :placeholder="$t('label.pleaseChooseApplicableBusiness')" dictCode="biz_type" v-model="queryParam.bizType" />
              </mtc-form-item>
            </a-col>
            <a-col :md="6" :sm="12">
              <mtc-form-item label="label.description">
                <a-input :placeholder="$t('tip.pleaseInput') + $t('label.description')" v-model="queryParam.description"></a-input>
              </mtc-form-item>
            </a-col>
<!--          </template>-->
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <!--<a-button type="primary" @click="searchQuery" icon="search">{{$t('button.search')}}</a-button>-->
              <!--<a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{$t('button.reset')}}</a-button>-->
              <mtc-button @click="searchQuery" type="primary" icon="search"  text="button.search"></mtc-button>
              <mtc-button @click="searchReset" type="primary" icon="reload"  style="margin-left: 8px" text="button.reset"></mtc-button>
<!--              <a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? $t('tip.up') : $t('tip.down') }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
              </a>-->
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <!--<a-button @click="handleAdd" type="primary" icon="plus">{{$t('button.add')}}</a-button>-->
      <mtc-button @click="handleAdd" type="primary" icon="plus"  text="button.add"></mtc-button>

      <!--<a-button type="primary" icon="download" @click="handleExportXls('sys_code_rule')">{{$-->
        <!--t('button.export')}}</a-button>-->
      <mtc-button @click="handleExportXls('sys_code_rule')" type="primary" icon="download"  text="button.export"></mtc-button>
      <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel">
        <!--<a-button type="primary" icon="import">{{$t('button.import')}}</a-button>-->
        <mtc-button type="primary" icon="import"  text="button.import"></mtc-button>
      </a-upload>

      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <!--<a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>{{$t('button.delete')}}</a-menu-item>-->
          <mtc-button  style="margin-left: 8px" type="delete" text="button.delete"></mtc-button>
        </a-menu>
        <!--<a-button style="margin-left: 8px"> {{$t('button.batchOperation')}} <a-icon type="down" /></a-button>-->
        <mtc-button  style="margin-left: 8px" type="down" text="button.batchOperation"></mtc-button>

      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> {{$t('tip.selected')}} <a style="font-weight: 600">{{ selectedRowKeys.length }}</a> {{$t('tip.term')}}
        <a style="margin-left: 24px" @click="onClearSelected">{{$t('button.clear')}}</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        class="j-table-force-nowrap"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :scroll="{x: true}"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        @change="handleTableChange">


        <template v-for="(item, index) in columns" :slot="item.slotName">
          <!--<span :key="index">{{ $t(item.slotName) }}</span>-->
          <mtcHeader :key="index" :text="item.slotName" />
        </template>

        <template :slot="item.dataIndex" slot-scope="text, record" v-for="item in columns">
          <a v-if="item.dataIndex == 'code'" :key="item.dataIndex" @click="handleDetail(record)">{{text}}</a>
          <div v-else-if="whetherLang(item.dataIndex)" :key="item.dataIndex">
            <a-popover placement="topLeft" arrow-point-at-center>
              <template slot="content">
                <div style="width: 200px;">
                  <a-row v-for="(sItem, sIndex) in record.secondLanguage" :key="sIndex">
                    <a-col :span="8" style="text-align:right;font-weight:bold;">{{sItem.langType}}：</a-col>
                    <a-col :span="16">{{sItem[item.dataIndex]}}</a-col>
                  </a-row>
                </div>
              </template>
              {{text}}
            </a-popover>
          </div>
          <div v-else :key="item.dataIndex">
            {{text}}
          </div>
        </template>

        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无图片</span>
          <img v-else :src="getImgView(text)" height="25px" alt="" style="max-width:80px;font-size: 12px;font-style: italic;"/>
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无文件</span>
          <a-button
            v-else
            :ghost="true"
            type="primary"
            icon="download"
            size="small"
            @click="uploadFile(text)">
            下载
          </a-button>
        </template>

        <span slot="action" slot-scope="text, record">
          <!--<a @click="handleEdit(record)">{{$t('button.edit')}}</a>-->
          <mtc-button @click="handleEdit(record)" type="link" size="small" text="button.edit"></mtc-button>
          <a-divider type="vertical" />
          <a-dropdown>
            <!--<a class="ant-dropdown-link">{{$t('button.more')}} <a-icon type="down" /></a>-->
            <mtc-button  type="link" size="small" text="button.more"></mtc-button>
            <a-menu slot="overlay">
              <a-menu-item>
                <a-popconfirm :title="$t('tip.isDelete')" @confirm="() => handleDelete(record.id)">
                  <!--<a>{{$t('button.delete')}}</a>-->
                  <mtc-button type="link" size="small" text="button.delete"></mtc-button>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>

      </a-table>
    </div>

    <sysCodeRule-modal ref="modalForm" @ok="modalFormOk"></sysCodeRule-modal>
  </a-card>
</template>

<script>

  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import SysCodeRuleModal from './modules/SysCodeRuleModal'
  import '@/assets/less/TableExpand.less'
  import { MTC_AUTH } from '@api/servers'

  export default {
    name: "SysCodeRuleList",
    mixins:[JeecgListMixin],
    components: {
      SysCodeRuleModal
    },
    data () {
      return {
        description: 'sys_code_rule管理页面',
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },
          {
            slotName: 'label.code',
            align:"center",
            dataIndex: 'code',
            scopedSlots: {
              title: 'label.code',
              customRender: 'code'
            }
          },
          {
            slotName: 'label.description',
            align:"center",
            dataIndex: 'name',
            scopedSlots: {
              title: 'label.description',
              customRender: 'name'
            }
          },
          {
            slotName: 'label.applicableBusiness',
            align:"center",
            dataIndex: 'bizType_dictText',
            scopedSlots: {
              title: 'label.applicableBusiness',
              customRender: 'bizType'
            }
          },
          {
            slotName: 'label.sort',
            align:"center",
            dataIndex: 'seq',
            scopedSlots: {
              title: 'label.sort',
              customRender: 'seq'
            }
          },
          {
            slotName: 'label.remarks',
            align:"center",
            dataIndex: 'description',
            scopedSlots: {
              title: 'label.remarks',
              customRender: 'description'
            }
          },
          {
            slotName: 'tableHeader.createdBy',
            align:"center",
            dataIndex: 'createBy',
            scopedSlots: {
              title: 'tableHeader.createdBy',
              customRender: 'createBy'
            }
          },
          {
            slotName: 'tableHeader.creationTime',
            align:"center",
            dataIndex: 'createTime',
            customRender:function (text) {
              return !text?"":(text.length>10?text.substr(0,10):text)
            },
            scopedSlots: {
              title: 'tableHeader.creationTime',
            }
          },
          {
            slotName: 'tableHeader.updateBy',
            align:"center",
            dataIndex: 'updateBy',
            scopedSlots: {
              title: 'tableHeader.updateBy',
              customRender: 'updateBy'
            }
          },
          {
            slotName: 'tableHeader.updateTime',
            align:"center",
            dataIndex: 'updateTime',
            customRender:function (text) {
              return !text?"":(text.length>10?text.substr(0,10):text)
            },
            scopedSlots: {
              title: 'tableHeader.updateTime',
            }
          },
          {
            slotName: 'label.department',
            align:"center",
            dataIndex: 'sysOrgCode',
            scopedSlots: {
              title: 'label.department',
              customRender: 'sysOrgCode'
            }
          },
          // {
          //   slotName: 'label.notes',
          //   align:"center",
          //   dataIndex: 'notes',
          //   scopedSlots: {
          //     title: 'label.notes',
          //     customRender: 'notes'
          //   }
          // },
          {
            slotName: 'tableHeader.whetherValid',
            align:"center",
            dataIndex: 'validFlag_dictText',
            scopedSlots: {
              title: 'tableHeader.whetherValid',
              customRender: 'validFlag'
            }
          },
          {
            slotName: 'tableHeader.operation',
            // title: '操作',
            dataIndex: 'action',
            scopedSlots: {customRender: 'action', title: 'tableHeader.operation'},
            align: "center",
            width: 170
          },

        ],
        url: {
          list: `${MTC_AUTH}system/sysCodeRule/list`,
          delete: `${MTC_AUTH}system/sysCodeRule/setDeleteWithSysCodeRuleDtl`,
          deleteBatch: `${MTC_AUTH}system/sysCodeRule/deleteBatchWithSysCodeRuleDtl`,
          exportXlsUrl: `${MTC_AUTH}system/sysCodeRule/exportXlsWithSysCodeRuleDtl`,
          importExcelUrl: `${MTC_AUTH}system/sysCodeRule/importExcelWithSysCodeRuleDtl`,
        },
        mainTable: "sys_code_rule",
        dictOptions:{},
      }
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      }
    },
    methods: {
      initDictConfig(){
      },
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>